// KeycloakContext.js
import { createContext } from "react";

const KeycloakContext = createContext(null);

export default KeycloakContext;
